var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invite-detail-wrapper" },
    [
      _c("invite-detail"),
      _vm._v(" "),
      _c("invite-trade", { staticClass: "invite-table" }),
      _vm._v(" "),
      _c("invite-order")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }